export default {
    methods: {
        getWindowWidth() {
            return window.innerWidth
        }
    }
}